var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.imageSrc)?_c('md-avatar',{staticClass:"user-profile-photo",style:({ 'background-image': `url(${_vm.imageSrc})` })}):_c('md-avatar',{staticClass:"user-profile-photo no-profile-photo"})
}
var staticRenderFns = []

export { render, staticRenderFns }